export const currentMortgageProductFeeTypes: MortgageProductFeeType[] = ['DEEDS_RELEASE_FEE', 'REDEMPTION_ADMIN_FEE']
